module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/apple.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/apple.png
// module id = 1208
// module chunks = 0